"use strict";

exports.__esModule = true;
exports.default = void 0;
const resolveColor = ({
  removable: removableColor,
  selected: selectedColor,
  normal: normalColor
}) => ({
  theme,
  selected,
  removable
}) => {
  if (removable && !selected) return theme.orbit[removableColor];
  if (selected) return theme.orbit[selectedColor];
  return theme.orbit[normalColor];
};
var _default = resolveColor;
exports.default = _default;